export default __webpack_public_path__ + "static/media/NewLeaves.e29c76a1.jpg";